import UPDATE_MY_INFO_ADDRESS_FORM from '../actionTypes/MyInfoAddressActionTypes';

function MyInfoAddressReducer(state = {}, action = {}) {
    if (action.type === UPDATE_MY_INFO_ADDRESS_FORM) {
        const { attribute, newValue } = action;
        return { ...state, [attribute]: newValue };
    }
    return state;
}

MyInfoAddressReducer.reducerName = 'myInfoAddressReducer';
export default MyInfoAddressReducer;
